import { Component, OnInit, OnChanges, SimpleChanges, ɵConsole, TemplateRef, ViewChild } from "@angular/core";
import { VproService } from "./../../service/vpro/vpro.service";
import { Appointment } from "../../models/appointment";
import { Physician } from "../../models/physician";
import { AllPatient } from "src/app/models/patient";
import { Timeoption } from "src/app/models/timeoption";
import {
  NgbDatepickerConfig,
  NgbDate,
  NgbCalendar,
  NgbDateParserFormatter,
  NgbModal,
  NgbDateStruct
} from "@ng-bootstrap/ng-bootstrap";
import { DashCred } from "src/app/models/dash";
import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
import { sortBy } from "underscore";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { DoctorCalendarComponent } from "src/app/component/doctor-calendar/doctor-calendar.component";
import { ActivatedRoute } from "@angular/router";
import { TrimFormValuesService } from "src/app/common/trimmingForm";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});
declare var $: any;
@Component({
  selector: "app-appointments-sidebar",
  templateUrl: "./appointments-sidebar.component.html",
  styleUrls: ["./appointments-sidebar.component.css"]
})
export class AppointmentsSidebarComponent implements OnInit {

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;

  termsUrl = Utils.termsUrl;
  isError: boolean;
  patient = [];
  show = false;
  public model: any;
  public model1: any;
  physician: any;
  pdata = [];
  phydata = [];
  appointment = new Appointment();
  physiciand = new Physician();
  allpatient = new AllPatient();
  dataValue: boolean;
  searchphy: any;
  submitted = false;
  interval: any;
  patientId: any;
  selectButtonName: string = "SELECT PATIENT";
  phyId: any;
  timer: any;
  appoint: string;
  showdropdown: any;
  dataOfPatient: any;
  birth: any;
  patid: any;
  firstName: string;
  lastName: string;
  isLoading: boolean;
  add: any;
  cont: any;
  data: any;
  message: any;
  patientIdOf: any;
  patientIdBasedData: AllPatient;
  appointmentForm: any;
  option = [new Timeoption("08.00 AM")];
  reset: any;
  myTime = this.option[0];
  index: any;
  preventSimpleClick = false;
  //let delay = 200;
  array: [];
  dcred = new DashCred();
  chkdet: any;
  selectPhysician: boolean;
  org_code: any;
  time1: any = { hour: 13, minute: 30 };
  meridian: Boolean = true;
  currentDate = Utils.maxDate;
  scheduleAppointmentForm: FormGroup;
  AppointmentType = Utils.APPOINTMENT_TYPE;
  termsAndCondition: boolean = true;
  isChecked: boolean = false;
  scheduleOptions: any;
  //org_codes: any;
  public workingHours = [];
  excludeDays: number[];
  forms = {

    reasonForm: null,
  };


  constructor(
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private service: VproService,
    config: NgbDatepickerConfig,
    private modal: NgbModal,
    // calendar: NgbCalendar,
    private utils: Utils,
    private route: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private trimFormValuesService: TrimFormValuesService,
  ) {

    //this.fromDate = calendar.getToday();
    //this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);

    this.forms.reasonForm = this._formBuilder.group({
      reasons: [""],
    });
  }

  ngOnInit() {

    console.log("this.scheduleOptions ", this.scheduleOptions);
    this.getOrgDet(localStorage.getItem("LogUsr"));

    //this.getAllPhysicians()


    this.scheduleAppointmentForm = this._formBuilder.group({
      drid: ['', Validators.required],
      startDate: ['', Validators.required],
      scheduleOptions: [null],
      endDate: [null],
      startTime: [Utils.timesNow, Validators.required],
      endTime: [Utils.constructTime(Utils.timesNow, Utils.defaultEndTimeAddon)]
    });

  }
  signUpUser(e: string): void {

    this.scheduleOptions = e;
  }
  onDateSelection(date: NgbDate, datepicker: any) {

    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;

    } else if (this.fromDate && !this.toDate && date) {
      this.toDate = date;
      console.log(" this.fromDate", this.fromDate)
      console.log(" this.toDate", this.toDate)
      datepicker.close();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    // console.log("this.fromDate is inside", this.fromDate);
    // console.log("this.toDate is inside", this.toDate);
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    // console.log("this.fromDate is range", this.fromDate);
    // console.log("this.toDate is range", this.toDate);
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  dateTimeChangeEvent(ev = null) {
    // Set EndTime
    let { startTime, startDate, endTime } = this.scheduleAppointmentForm.value;
    if (endTime) {
      this.validateEndTime();
    }
    else {
      this.scheduleAppointmentForm.patchValue({
        endTime: Utils.constructTime(startTime, Utils.defaultEndTimeAddon)
      })
    }
    // Validate Start Time
    let isInvalid = Utils.validateStartTime(startTime, startDate);

    if (isInvalid) {
      this.scheduleAppointmentForm.controls['startTime'].setErrors({ 'invalidStartTime': isInvalid })
    }
    else {
      this.scheduleAppointmentForm.controls['startTime'].setErrors(null)
    }
  }

  validateEndTime(e = null) {
    let { startTime, endTime } = this.scheduleAppointmentForm.value;
    let isInvalid = Utils.validateEndTime(startTime, endTime);
    if (isInvalid) {
      this.scheduleAppointmentForm.controls['endTime'].setErrors({ 'invalidEndTime': true })
    }
    else {
      this.scheduleAppointmentForm.controls['endTime'].setErrors(null)
    }
  }

  getAllPhysicians() {
    // console.log("Org code", this.org_code);
    try {
      let searchFields = { org_code: this.org_code };
      // console.log("searchFields_getallPhysicians", searchFields);
      let userRoles = JSON.parse(localStorage.getItem("LogUsrTyp"));

      if (this.utils.checkRoleType(Utils.USER_TYPE.physician, userRoles) && !this.utils.checkRoleType(Utils.USER_TYPE.admin, userRoles)) {
        searchFields['u_id'] = parseInt(localStorage.getItem('uid'));
      }
      this.service.fetchPhysicians(searchFields, `?test_user=true`).subscribe((result: Physician[]) => {
        this.physician = result['result'];
        this.physician = this.physician.map(p => {
          p.fullname = `${p.first_name} ${p.last_name}`;
          return p;
        });

        this.org_code = this.physician[0].org_code;

      });
    }
    catch (e) {
      console.log(e);
    }
  }

  fetchPatients(searchFields) {
    //console.log("this.fromDate", this.fromDate);
    console.log("searchFields1", searchFields);
    this.trimFormValuesService.trimValues(searchFields);

    try {
      searchFields.name = (searchFields.name && searchFields.name.length > 0) ? searchFields.name : null;
      searchFields.pid = (searchFields.pid && searchFields.pid.length > 0) ? searchFields.pid : null;


      if (this.fromDate == null) {
        searchFields['fromDate'] = null
      }
      if (this.toDate == null) {
        searchFields['toDate'] = null
      }

      if (this.fromDate) {
        searchFields['fromDate'] = this.fromDate.year + "-" + this.fromDate.month + "-" + this.fromDate.day
      }

      if (this.toDate) {
        searchFields['toDate'] = this.toDate.year + "-" + this.toDate.month + "-" + this.toDate.day
      }
      if (this.fromDate != null && this.toDate == null) {
        searchFields['toDate'] = searchFields['fromDate'];
      }


      //working
      // if (Appointment.length == 0) {
      searchFields.org_code = this.org_code;
      // }


      console.log("searchFields", searchFields);
      this.spinner.show();
      this.service.fetchPatients(searchFields).subscribe((result: AllPatient[]) => {
        this.pdata = result;
        this.spinner.hide();
        this.pdata = sortBy(this.pdata, 'first_name'); // Data Sorter via underscore.js

        for (let i = 0; i < this.pdata.length; i++) {
          this.pdata[i].name = this.pdata[i].first_name.trim() + ' ' + this.pdata[i].last_name.trim();
          // this.users[i].ppurl = this.users[i].ppurl;
          this.pdata[i].avatarimg = this.pdata[i].ppurl.substring(this.pdata[i].ppurl.lastIndexOf('/') + 1);
          // console.log("avatar for Phy", this.users[i].avatarimg);
        }

      })
    }
    catch (e) {
      this.spinner.hide();
      console.log(e);
    }
  }

  getOrgDet(usereid: string) {
    try {
      this.spinner.show();
      this.service.getOrgDet(this.dcred).subscribe(
        (res) => {
          this.org_code = res[0].org_code;
          this.spinner.hide();
          this.getAllPhysicians();
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }


  clearSearch() {
    this.appointment["name"] = null;
    this.appointment["pid"] = null;
  }
  /* function that empties the above result*/
  empty() {
    this.pdata.length = 0;
  }

  /**function patientSelection for select the patient */
  patientSelection(data) {
    //  document.documentElement.scrollTop = document.documentElement.scrollHeight;
    this.spinner.show();
    this.patientIdOf = data;
    this.scheduleOptions = 0;
    this.pdata.filter(element => {
      if (element["pid"] == this.patientIdOf) {
        document.getElementById(element["pid"]).innerHTML = "SELECTED";
        this.patientIdBasedData = element;
        console.log("this.patientIdBasedData ", this.patientIdBasedData);
      }
      else {
        document.getElementById(element["pid"]).innerHTML = "SELECT PATIENT"
      }
    });
    this.selectPhysician = true;
    this.spinner.hide();
  }

  getToBottom() {
    setTimeout(x => {
      document.documentElement.scrollTop = document.documentElement.scrollHeight;
    }, 1000)
  }

  getToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  /**function addSchedule for add the schedule */
  addSchedule(data2) {

    let { day: startDay, month: startMonth, year: startYear } = this.scheduleAppointmentForm.value.startDate;
    let type = this.scheduleOptions;
    let onlinecheckin;

    if (type == 0)
      onlinecheckin = false;
    else
      onlinecheckin = true;

    let data = {
      reason: this.forms.reasonForm.value?.reasons,
      type: this.AppointmentType.IN_PERSON,
      pid: this.patientIdBasedData.pid,
      drid: this.scheduleAppointmentForm.value.drid,
      aptname: `Consultation : ${this.patientIdBasedData.first_name} ${this.patientIdBasedData.last_name}`,
      apdate: startYear + "-" + startMonth + "-" + startDay,
      aptime: this.scheduleAppointmentForm.value.startTime.hour + ':' + this.scheduleAppointmentForm.value.startTime.minute,
      uid: JSON.parse(localStorage.getItem("uid")),
      online_checkin: onlinecheckin,// for inperson - video call appointment
      createdat: this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day
    };

    if (this.scheduleAppointmentForm.value.endDate) {
      let { year, month, day } = this.scheduleAppointmentForm.value.endDate;
      data['enddate'] = year + "-" + month + "-" + day;
    }
    if (this.scheduleAppointmentForm.value.endTime) {
      let { hour, minute } = this.scheduleAppointmentForm.value.endTime;
      data['endtime'] = `${hour}:${minute}`;
    }

    this.spinner.show();

    this.service.addSchedule(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        let { message } = res;
        this.showToast('success', message);
        setTimeout(() => {
          this.reload();
        }, 1000)
      },
      err => {
        this.spinner.hide();
        let message = "Something wrong. Couldn't schedule appointment.";
        if (err && err.error && err.error.error) {
          this.showToast('error', err.error.error);
          return;
        }
        this.showToast('error', message);
      }
    );
  }

  resetForm(form) {
    form.reset();
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  reload() {
    location.reload();
  }



  // openCalendarModal() {
  //   const modalRef = this.modalService.open(DoctorCalendarComponent, {
  //     backdropClass: 'modal-backdrop',
  //     size: 'lg',
  //     centered: true,
  //     backdrop: 'static'
  //   });


  //   // modalRef.componentInstance.disabledDates = [
  //   //   new Date(2024, 3, 15), // Example disabled dates
  //   //   new Date(2024, 3, 20)
  //   // ];
  //   modalRef.componentInstance.drid = this.scheduleAppointmentForm.value.drid;
  //   modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
  //     this.patchDateAndTime(receivedEntry);
  //     modalRef.close();
  //   });

  //   modalRef.componentInstance.closeModal.subscribe((val) => {
  //     modalRef.dismiss();
  //   });
  //   //   modalRef.componentInstance.drid = this.scheduleAppointmentForm.value.drid;

  //   //   modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
  //   //     this.patchDateAndTime(receivedEntry);
  //   //     modalRef.close();
  //   //   })

  //   //   modalRef.componentInstance.closeModal.subscribe((val) => {
  //   //     modalRef.dismiss();
  //   //   })
  //   modalRef.result.then(
  //     (result) => {
  //       console.log("result", result);
  //     },
  //     (reason) => {
  //       console.log("reason", reason);
  //     }
  //   );
  // }

  openCalendarMOdal() {
    const modalRef = this.modalService.open(DoctorCalendarComponent, { backdropClass: 'modal-backdrop', size: 'lg', centered: true, backdrop: 'static' });

    modalRef.componentInstance.drid = this.scheduleAppointmentForm.value.drid;

    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.patchDateAndTime(receivedEntry);
      modalRef.close();
    })
    // modalRef.componentInstance.disableWeekends = (date: NgbDateStruct) => {
    //   const jsDate = new Date(date.year, date.month - 1, date.day);
    //   const day = jsDate.getDay();
    //   // Check if the day is included in the excluded days array or if it's included in the disabledDates array
    //   return this.excludeDays.includes(day) || modalRef.componentInstance.disabledDates.some(disabledDate => {
    //     return disabledDate.getFullYear() === jsDate.getFullYear() &&
    //            disabledDate.getMonth() === jsDate.getMonth() &&
    //            disabledDate.getDate() === jsDate.getDate();
    //   });
    // };
    modalRef.componentInstance.closeModal.subscribe((val) => {
      modalRef.dismiss();
    })

    modalRef.result.then(
      (result) => {
        console.log("result", result);
      },
      (reason) => {
        console.log("reason", reason);
      }
    );
  }

  patchDateAndTime(dateTime) {
    this.scheduleAppointmentForm.patchValue({
      startDate: { year: parseInt(moment(dateTime).format('YYYY')), month: parseInt(moment(dateTime).format('MM')), day: parseInt(moment(dateTime).format('DD')) },
      startTime: { hour: parseInt(moment(dateTime).format('HH')), minute: parseInt(moment(dateTime).format('mm')) },
      endTime: Utils.constructTime({ hour: parseInt(moment(dateTime).format('HH')), minute: parseInt(moment(dateTime).format('mm')) }, Utils.defaultEndTimeAddon)
    })
    this.dateTimeChangeEvent();
  }

  tacChecked(evt) {
    let target = evt.target;
    this.termsAndCondition = target.checked;
  }
  resetfn() {
    this.spinner.show();
    window.location.reload();
  }
  refresh(appointment) {
    this.toDate = null;
    this.fromDate = null;
    appointment['name'] = '';
    appointment['contact'] = null;
    appointment['city'] = '';
    appointment['fromDate'] = null;
    appointment['toDate'] = null;


  }

  // optionChanged(event) {
  //   console.log("events", event)
  //   console.log("event.target.value", event.target.value)
  //   this.getDefaultWorkingHours(event.target.value)

  // }
  getDayName = {
    '0': 'Sun',
    '1': 'Mon',
    '2': 'Tue',
    '3': 'Wed',
    '4': 'Thu',
    '5': 'Fri',
    '6': 'Sat'
  }
  getDefaultWorkingHours(dr_id) {
    let drid = dr_id;
    this.spinner.show();
    this.service.getWorkingHours(drid).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && res.length > 0) {
          this.workingHours = res;
          this.excludeDays = [];
          this.workingHours.map(x => {
            x.dayName = this.getDayName[x.day];
            x.start_time = x.start_time.split(':');
            x.start_time = { hour: parseInt(x.start_time[0]), minute: parseInt(x.start_time[1]) };
            x.end_time = x.end_time.split(':');
            x.end_time = { hour: parseInt(x.end_time[0]), minute: parseInt(x.end_time[1]) };
            if (x.start_time.hour === x.end_time.hour && x.start_time.minute === x.end_time.minute) {
              x.Checked = true;
            } else {
              x.Checked = false;
            }
          });
        }
        this.excludeDays = this.workingHours.filter(day => day.Checked).map(day => day.day);

        console.log("getWorkingHours", this.workingHours);
        console.log("excludeDays", this.excludeDays);


      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
  }
  disableWeekends = (date: NgbDateStruct) => {
    const day = new Date(date.year, date.month - 1, date.day).getDay();
    return this.excludeDays.includes(day);
  }

}
